import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2, },
  },
};

const projectVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1}
};

// const Project = ({ title }) => {
//   const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
//     bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
//   const projectTitle = title.split(" ").join("-").toLowerCase();
  
//   return (
//     <motion.div variants={projectVariant} className="relative">
//       <div className={overlayStyles}>
//         <p className="text-2xl font-playfair">{title}</p>
//         <p className="mt-7">
//             Hellor arcu erat, accumsan id emperdiet et, porttitor at sem. Nulla 
//             porttitor accumsan tincident.
//         </p>
//       </div>
//       <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
//     </motion.div>
//   );
// };

const Project1 = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();
  const name = "Andromeda";
  return (
    <motion.div variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{name}</p>
        <p className="mt-7">
        Andromeda was the daughter of King Cepheus of Ethiopia and Queen Cassiopeia, 
        who offended the Nereids (sea nymphs) by claiming she was more beautiful than them.
        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
    </motion.div>
  );
};

const Project2 = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();
  const name = "Draco";
  return (
    <motion.div variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{name}</p>
        <p className="mt-7">
            Draco is the dragon that guards the golden apple tree in Greek Mythology. The name is derived 
            from the Latin term draconem, meaning "huge serpent," and the constellation literally snakes 
            its way through the northern sky.
        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
    </motion.div>
  );
};

const Project3 = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();
  const name = "Pisces";
  return (
    <motion.div variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{name}</p>
        <p className="mt-7">
            Pisces represents two fish swimming next to each other. According to Greek mythology, the fish 
            represent the goddess Aphrodite and her son, Eros. They are said to have transformed into fish 
            and plunged into the Euphrates River to escape the fearsome monster Typhon.
        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
    </motion.div>
  );
};

const Project4 = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();
  const name = "Sagitarrius";
  return (
    <motion.div variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{name}</p>
        <p className="mt-7">
            Sagittarius constellation is one of the first constellations catalogued in the 2nd century. 
            It represents the archer, usually depicted as a centaur holding a bow and arrow. In mythology, 
            it is also associated with Crotus, the satyr who kept the company of the Muses on Mount Helicon.

        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
    </motion.div>
  );
};

const Project5 = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();
  const name = "Cygnus";
  return (
    <motion.div variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{name}</p>
        <p className="mt-7">
            Cygnus represents a swan. When Zeus strikes a stubborn charioteer with lightning causing him to fall 
            into the river, his close friend, Cygnus, asks Zeus for help saving him. Zeus transforms Cygnus into a swan 
            so he can dive into the river. To honor this sacrifice for his friend, Zeus kept Cygnus in the stars.
        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
    </motion.div>
  );
};

const Project6 = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();
  const name = "Dorado";
  return (
    <motion.div variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{name}</p>
        <p className="mt-7">
            Dorado constellation lies in the southern hemisphere. Its name means “the dolphinfish” 
            (Coryphaena hippurus) in Spanish. The constellation has also been depicted as a swordfish.
        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
    </motion.div>
  );
};

const Project7 = ({ title }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();
  const name = "Grus";
  return (
    <motion.div variants={projectVariant} className="relative">
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{name}</p>
        <p className="mt-7">
            Grus, reperesenting a crane, was one of the 12 constellations recorded by Dutch explorers in the late 16th century. 
            The only connection the crane has with mythology lies in the fact that it was a sacred bird to the god Hermes.
        </p>
      </div>
      <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
    </motion.div>
  );
};

const Projects = () => {
  return (
    <section id="projects" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
          className="md:w-2/5 mx-auto text-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: -50 },
            visible: {opacity: 1, y: 0}
          }}
        > 
           <div>
            <p className="font-playfair font-semibold text-4xl">
                <span className="text-red">CONST</span>ELLATIONS
            </p>
            <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
            </div>
          </div>

          <p className="mt-10 mb-10">
              Learn more about the different constellations in the night sky!
          </p>
        </motion.div>

    {/* PROJECTS */}
    <div className="flex justify-center">
      <motion.div
          className="sm:grid sm:grid-cols-3"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={container}
      >
        {/* ROW 1 */}
        <div
          className="flex justify-center text-center items-center p-10 bg-red 
            max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
        >
          SEVEN CONSTELLATIONS TO LOOK INTO
        </div>
        <Project1 title="Project 1" />
        <Project2 title="Project 2" />

        {/* ROW 2 */}
        <Project3 title="Project 3" />
        <Project4 title="Project 4" />
        <Project5 title="Project 5" />

        {/* ROW 3 */}
        <Project6 title="Project 6" />
        <Project7 title="Project 7" />
        <div
          className="flex justify-center text-center items-center p-10 bg-blue 
            max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
        >
          WHICH WAS YOUR FAVORITE?
        </div>
      </motion.div>
    </div>
    </section>
  );
};

export default Projects;